import { Form } from 'antd';
import Text from 'components/Text';
import { ITimelineItem } from 'features/appointment/utils/getTimeLines';
import moment from 'moment';
import styled from 'styled-components';
import CalendarPicker from '../QuickBooking/CalendarPicker';
import { TYPE_BLOCK_RADIO } from './BlockHourType';
import RangerPickerDayOffs from './RangerPickerDayOffs';
import StartTimes from './StartTimes';

type Props = {
  value?: TYPE_BLOCK_RADIO;
};
const TimeDateBlockHour = ({ value }: Props) => {
  const form = Form.useFormInstance();
  const timeOptions: ITimelineItem[] = Form.useWatch('timeOptions', form) || [];

  if (value === TYPE_BLOCK_RADIO.DAY_OFF)
    return (
      <DateOffsContainer>
        <div className='date-off-label'>DATE OFFS</div>
        <Form.Item name={'dateOffs'} rules={[{ required: true }]} style={{ width: '100%' }}>
          <RangerPickerDayOffs />
        </Form.Item>
      </DateOffsContainer>
    );
  if (value === TYPE_BLOCK_RADIO.BLOCK_HOURS)
    return (
      <>
        <Form.Item noStyle name={'timeOptions'} />
        <Form.Item noStyle name={'date'} rules={[{ required: true }]}>
          <CalendarPicker />
        </Form.Item>
        <LabelTimeSection variant='H9' color='text_3' className='text-lg label-time-section'>
          Start Time
        </LabelTimeSection>
        <ContainerTimes>
          <div className='children-content'>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const date = getFieldValue('date');
                const now = moment();
                const times = date?.isSame(now, 'day')
                  ? timeOptions.filter((o) => o.value > now)
                  : timeOptions;
                return (
                  <>
                    <Form.Item noStyle name={'startTime'} rules={[{ required: true }]}>
                      <StartTimes
                        options={times}
                        onChange={() => form.setFieldValue('endTime', null)}
                      />
                    </Form.Item>
                  </>
                );
              }}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const startTime = getFieldValue('startTime');
                if (!startTime) return null;
                const times = timeOptions.filter((o) => o.value > startTime?.value);
                return (
                  <>
                    <LabelTimeSection variant='H9' color='text_3' className='text-lg label-time-section'>
                      End Time
                    </LabelTimeSection>
                    <Form.Item noStyle name={'endTime'} rules={[{ required: true }]}>
                      <StartTimes options={times} />
                    </Form.Item>
                  </>
                );
              }}
            </Form.Item>
          </div>
        </ContainerTimes>
      </>
    );
  if (value === TYPE_BLOCK_RADIO.ON_BREAK)
    return (
      <>
        <Form.Item noStyle name={'date_break'} rules={[{ required: true }]}>
          <CalendarPicker />
        </Form.Item>
        <Text variant='H9' color='text_3' className='text-lg'>
          Start Time
        </Text>
        <ContainerTimes>
          <div className='children-content'>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const date = getFieldValue('date_break');
                const now = moment();
                const times = date?.isSame(now, 'day')
                  ? timeOptions.filter((o) => o.value > now)
                  : timeOptions;
                return (
                  <>
                    <Form.Item noStyle name={'startTime_break'} rules={[{ required: true }]}>
                      <StartTimes
                        options={times}
                        onChange={() => form.setFieldValue('endTime_break', null)}
                      />
                    </Form.Item>
                  </>
                );
              }}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const startTime = getFieldValue('startTime_break');
                if (!startTime) return null;
                const times = timeOptions.filter((o) => o.value > startTime?.value);
                return (
                  <>
                    <Text variant='H9' color='text_3' className='text-lg'>
                      End Time
                    </Text>
                    <Form.Item noStyle name={'endTime_break'} rules={[{ required: true }]}>
                      <StartTimes options={times} />
                    </Form.Item>
                  </>
                );
              }}
            </Form.Item>
          </div>
        </ContainerTimes>
      </>
    );
  return null;
};

export default TimeDateBlockHour;

const LabelTimeSection = styled(Text)`
  background: rgb(255, 229, 119);
  font-size: 24px !important;
  margin-bottom: 4px;
  padding: 8px 0px;
`;

const DateOffsContainer = styled.div`
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  .date-off-label {
    color: #505050;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 111.111% */
    text-transform: capitalize;
  }
`;

const ContainerTimes = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  .children-content {
    position: absolute;
    inset: 0;
    overflow: auto;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
`;
